import { render, staticRenderFns } from "./SelectRole.vue?vue&type=template&id=150c174a&scoped=true&"
import script from "./SelectRole.vue?vue&type=script&lang=js&"
export * from "./SelectRole.vue?vue&type=script&lang=js&"
import style0 from "./SelectRole.vue?vue&type=style&index=0&id=150c174a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150c174a",
  null
  
)

export default component.exports